import { oc } from "@orpc/contract";
import * as z from "zod";

const Id = z.string().min(1).max(200);

/** The audit actions the app writes, so the admin page can name each one in every locale. */
export const DROK_AUDIT_ACTIONS = [
  "user.it_granted",
  "user.it_revoked",
  "user.blocked",
  "user.unblocked",
  "template.published",
  "template.version_published",
  "template.archived",
  "assignment.assigned",
  "assignment.unassigned",
  "copy.pushed",
  "copy.push_failed",
  "company_model.created",
  "company_model.updated",
  "company_model.removed",
  "company_model.enabled",
  "company_model.disabled",
] as const;

export const DrokAuditEventSchema = z.object({
  id: Id,
  /** A user id, or "cli". */
  actor: z.string(),
  actorEmail: z.string().nullable(),
  action: z.string(),
  targetUserId: z.string().nullable(),
  targetEmail: z.string().nullable(),
  templateId: z.string().nullable(),
  version: z.number().int().nullable(),
  botId: z.string().nullable(),
  details: z.record(z.string(), z.unknown()),
  createdAt: z.string(),
});
export type DrokAuditEventRow = z.infer<typeof DrokAuditEventSchema>;

const OkSchema = z.object({ ok: z.literal(true) });

/** IT-only: not in the employee access map, so default-deny. */
export const drokUserAdminContract = {
  grantIt: oc.input(z.object({ userId: Id })).output(OkSchema),
  revokeIt: oc.input(z.object({ userId: Id })).output(OkSchema),
  block: oc
    .input(z.object({ userId: Id, reason: z.string().trim().max(500).optional() }))
    .output(OkSchema),
  unblock: oc.input(z.object({ userId: Id })).output(OkSchema),
};

export const drokAuditContract = {
  list: oc
    .input(
      z
        .object({
          action: z.string().min(1).max(100).optional(),
          targetUserId: Id.optional(),
          cursor: z.string().max(500).optional(),
          limit: z.number().int().min(1).max(200).default(50),
        })
        .default({ limit: 50 }),
    )
    .output(z.object({ events: z.array(DrokAuditEventSchema), nextCursor: z.string().nullable() })),
};
